export default __webpack_public_path__ + "static/media/5.da303a99.webp";